import PropTypes from 'prop-types';
import { Map } from 'immutable';
import React, { useState } from 'react';
import CheckoutController from '../../../event_components/Checkout';
import Title from '../../../event_components/title';
import { EventDate } from '../../../event_components/event-date';
import { EventTime } from '../../../event_components/event-time';
import { LocationItem } from '../../../new-event-layouts/shared/location-item/location-item';
import Details from '../../../event_components/details';
import AttendButton from '../../../event_components/attend_button';
import styles from './styles.scss';
import Gallery from '../../../new-event-layouts/shared/gallery';
import DateRangeIcon from '@mui/icons-material/DateRange';
import WatchLaterSharpIcon from '@mui/icons-material/WatchLaterSharp';

const MobileStackSecondView = ({ event, settings, onResizeComponent }) => {
  const isShowLocation = !event.get('venue', Map()).get('address').isEmpty();
  const [ticketOpen, setTicketOpen] = useState(false);

  return (
    <CheckoutController
      variant="default"
      event={event}
      settings={settings}
      openTicketing={ticketOpen}
      inClassName={styles.customCheckout}
      onResizeComponent={onResizeComponent}
      onClose={() => {
        setTicketOpen(false);
      }}
    >
      <React.Fragment>
        <Gallery event={event} />
        <div className={styles.info}>
          <Title event={event} settings={settings} className={styles.title} />
          <div className={styles.eventFactsList}>
            <div className={styles.factItem}>
              <DateRangeIcon alt="date" width="20px" className="date" />
              <EventDate event={event} settings={settings} />
            </div>
            <div className={styles.factItem}>
              <WatchLaterSharpIcon alt="time" width="20px" className="date" />
              <EventTime event={event} settings={settings} />
            </div>
            {isShowLocation && <LocationItem event={event} settings={settings} className={styles.locationItem} />}
          </div>
        </div>
        <div className={styles.attendButtonWrapper}>
          <AttendButton isFullWidth settings={settings} event={event} handleButtonClick={() => setTicketOpen(true)} />
        </div>
        <Details event={event} settings={settings} onResizeComponent={onResizeComponent} />
      </React.Fragment>
    </CheckoutController>
  );
};

MobileStackSecondView.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export default MobileStackSecondView;
